export const JWT_TOKEN = 'JWT_TOKEN'
export const LOGGED_IN = 'LOGGED_IN'
export const JSESSIONID = "JSESSIONID"
export const REFRESH_TOKEN = "REFRESH_TOKEN"
export const CUSTOMER_ID = "CUSTOMER_ID"